import React from 'react';

export default function IconSet() {
  return (
    <svg className="dn" xmlns="http://www.w3.org/2000/svg">
      <symbol
        id="icon-extras-potty-training"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M18.021 16.457c1.985-1.29 2.461-2.905 2.554-3.739.297-2.646-1.64-4.399-3.724-5.41-.575-.281-1.255-.63-1.882-.736.024.098 1.127 1.922-1.948 4.483-.88.736-1.516 1.955-1.396 3.108.091.855.579 1.658 1.256 2.238"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M11.628 13.378c-2.282.139-4.108 2.129-4.108 4.56 0 .176.024.34.048.517 0 .025.013.063.013.087C5.55 18.932 4 20.785 4 23.027c0 2.52 1.97 4.083 4.36 4.574 4.938.742 13.658.49 15.665 0C26.08 27.084 28 25.548 28 23.027c0-2.255-1.549-4.106-3.59-4.485.022-.2.047-.402.047-.604 0-2.405-1.765-4.37-4.012-4.547"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7.573 18.45c.428 3.602 5.381 5.05 9.159 4.105M22.668 21.218c.63-.445 1.577-1.338 1.747-2.769"
        />
      </symbol>
      <symbol
        id="icon-extras-puppy-starter-kit"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M9.75 27.266h12.5c.527 0 1.033-.206 1.412-.573l2.07-2.009c.393-.382.615-.907.615-1.454V13.38c0-1.12-.908-2.026-2.028-2.026H7.68c-1.12 0-2.027.907-2.027 2.026v9.849c0 .547.221 1.072.615 1.454l2.07 2.009c.378.367.885.573 1.412.573Z"
          clipRule="evenodd"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M22.602 11.354V7.573c0-.469-.2-.914-.548-1.226l-1.9-1.702a1.647 1.647 0 0 0-1.099-.42h-6.112c-.405 0-.796.15-1.097.42l-1.9 1.702a1.643 1.643 0 0 0-.548 1.226v3.78M12.585 7.403h6.83M12.585 11.355V4.31m6.83 7.045V4.31M16.008 15.28v-.059M16 15.045a.26.26 0 1 0 .003.517.26.26 0 0 0-.003-.517ZM19.767 17.19v-.06m-.008-.175a.26.26 0 1 0 .003.518.26.26 0 0 0-.003-.518ZM12.265 17.19v-.06m-.008-.175a.26.26 0 1 0 .003.518.26.26 0 0 0-.003-.518Z"
        />
        <path
          stroke="currentColor"
          strokeWidth="1.44"
          d="M16.044 23.109c1.575 0 3.573 1.365 3.545-.736-.012-1.576-1.653-3.054-3.545-3.056-1.902 0-3.792 1.607-3.53 3.245.29 1.9 2.135.547 3.53.547Z"
        />
      </symbol>
      <symbol
        id="icon-extras-registration"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M20.93 26.312a3.096 3.096 0 0 1-2.235.953h-8.094c-3.762 0-6.121-2.664-6.121-6.434V10.66c0-3.771 2.348-6.434 6.121-6.434h10.795c3.776 0 6.124 2.663 6.124 6.434V18.2c0 .8-.309 1.568-.863 2.146l-5.728 5.965Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M19.425 27.173v-4.37a3.866 3.866 0 0 1 3.858-3.868h4.139M13.695 8.819v-.066m-.008-.196a.289.289 0 1 0 .003.575.289.289 0 0 0-.003-.575ZM17.874 10.941v-.066m-.008-.196a.288.288 0 1 0 .003.575.288.288 0 0 0-.003-.575ZM9.535 10.941v-.066m-.008-.196a.288.288 0 1 0 .003.575.288.288 0 0 0-.003-.575Z"
        />
        <path
          stroke="currentColor"
          strokeWidth="1.44"
          d="M13.736 17.244c1.75 0 3.97 1.517 3.939-.818-.013-1.75-1.837-3.394-3.939-3.396-2.115 0-4.215 1.786-3.924 3.607.323 2.11 2.373.607 3.924.607Z"
        />
      </symbol>
      <symbol
        id="icon-extras-toys"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M16 28C9.373 28 4 22.628 4 16 4 9.373 9.373 4 16 4c6.628 0 12 5.373 12 12 0 6.628-5.372 12-12 12Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M8 7.056A11.97 11.97 0 0 1 12 16a11.97 11.97 0 0 1-4 8.945M24 7.056A11.97 11.97 0 0 0 20 16a11.97 11.97 0 0 0 4 8.945"
        />
      </symbol>
      <symbol
        id="icon-extras-vet-records"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M18.974 8.43h-5.948a1.736 1.736 0 0 1-1.736-1.735V5.96c0-.959.777-1.736 1.736-1.736h5.948c.959 0 1.736.777 1.736 1.736v.734c0 .959-.777 1.736-1.736 1.736Z"
          clipRule="evenodd"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M20.71 6.265a4.806 4.806 0 0 1 4.806 4.806v11.388a4.806 4.806 0 0 1-4.805 4.806h-9.42a4.806 4.806 0 0 1-4.806-4.806V11.071a4.806 4.806 0 0 1 4.806-4.806"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M15.998 13.062v-.066m-.009-.196a.288.288 0 1 0 .003.575.288.288 0 0 0-.003-.575ZM20.177 15.185v-.066m-.009-.196a.288.288 0 1 0 .003.575.288.288 0 0 0-.003-.575ZM11.838 15.185v-.066m-.009-.196a.288.288 0 1 0 .004.575.288.288 0 0 0-.004-.575Z"
        />
        <path
          stroke="currentColor"
          strokeWidth="1.44"
          d="M16.039 21.488c1.75 0 3.97 1.517 3.938-.818-.013-1.75-1.836-3.394-3.938-3.396-2.115 0-4.216 1.785-3.924 3.606.322 2.111 2.372.608 3.924.608Z"
        />
      </symbol>
      <symbol
        id="icon-extras-basic-obedience"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M18.906 27.354H12.38M15.81 12.555c-.316 1.49-1.813 2.452-3.536 4.222-2.937 3.016-3.003 7.999-2.703 10.808-4.03-.722-4.653-5.291-2.06-8.047M14.562 19.46c2.722 0 4.503 4.65 1.914 7.651"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M24.954 27.434H22.45c-.162-1.992-1.087-3.341 0-7.835.76-3.146.319-4.923-.262-8.021h2.143c2.068 0 2.701-2.277 2.802-3.476l-3.151-1.567c-.188-.604-.363-2.118-2.313-2.365l-1.378-.212c-1.694-.248-3.524.31-4.436 3.004-1.492 4.41-.194 5.728.642 5.836 2.954.548 2.889-3.513 2.664-5.284"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M14.1 14.094c1.72 1.224 6.067 3.269 9.699 1.657"
        />
      </symbol>
      <symbol
        id="icon-extras-food-and-treats"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="m5.76 25.36.966-5.482a2.56 2.56 0 0 1 2.535-2.197h13.478a2.56 2.56 0 0 1 2.535 2.197l.966 5.483M4.48 25.36h23.04M18.362 17.645l-4.846-7.392a2.242 2.242 0 1 0-2.444-3.762 2.24 2.24 0 0 0-.992 2.195 2.238 2.238 0 0 0-3.067 3.119 2.241 2.241 0 0 0 3.102.658l3.248 5.182M19.253 7.396l.165 1.077M22.939 12.51l1.157-.051M13.303 21.782h5.394"
        />
      </symbol>
      <symbol
        id="icon-extras-blanket-with-scent"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M6.397 11.618v11.104a3.922 3.922 0 0 0 3.922 3.921h11.365a3.922 3.922 0 0 0 3.922-3.921V11.618"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="m27.52 13.129-9.633-7.626a3.043 3.043 0 0 0-3.774 0L4.48 13.13"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M15.998 12.218v-.066m-.009-.195a.288.288 0 1 0 .003.575.288.288 0 0 0-.003-.575ZM20.175 14.34v-.065m-.008-.196a.288.288 0 1 0 .004.575.288.288 0 0 0-.004-.575ZM11.838 14.34v-.065m-.009-.196a.288.288 0 1 0 .004.575.288.288 0 0 0-.004-.575Z"
        />
        <path
          stroke="currentColor"
          strokeWidth="1.44"
          d="M16.039 20.918c1.75 0 3.97 1.517 3.938-.818-.013-1.751-1.836-3.395-3.938-3.397-2.115 0-4.216 1.786-3.924 3.607.322 2.111 2.372.608 3.924.608Z"
        />
      </symbol>
      <symbol
        id="icon-extras-microchip"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M19.32 28.093c0 .347-.293.64-.64.64h-6.533a.64.64 0 0 1 0-1.28h3.6v-.026c1.413-1.64 1.266-3.68.693-4.907-.48-1.053-1.28-1.68-2.12-1.68a.64.64 0 0 1 0-1.28c1.36 0 2.587.907 3.28 2.427.64 1.386.867 3.546-.293 5.466h1.36c.346 0 .64.294.64.64h.013Zm3.413-15.146c.214 1.093.387 2.04.467 2.986.04-.013.08-.026.107-.04a.63.63 0 0 1 .84.32.63.63 0 0 1-.32.84 7.28 7.28 0 0 1-.574.214c0 .96-.12 1.986-.413 3.2-.773 3.226-.493 4.693-.213 6.106.066.32.12.614.16.934h1.933c.347 0 .64.293.64.64 0 .346-.293.64-.64.64h-2.507a.64.64 0 0 1-.64-.587c-.04-.48-.12-.92-.213-1.387-.293-1.48-.613-3.16.227-6.653.24-.973.346-1.8.373-2.573-.44.066-.893.106-1.333.106-2.32 0-4.574-.866-6.094-1.72-.24.227-.48.467-.746.707-.4.373-.84.787-1.294 1.253-2.946 3.027-2.746 8.2-2.52 10.294.027.2-.053.4-.2.533a.676.676 0 0 1-.44.173h-.106c-1.907-.346-3.32-1.52-3.88-3.226-.64-1.947-.067-4.267 1.466-5.894a.648.648 0 0 1 .907-.026c.253.24.267.653.027.906-1.214 1.294-1.68 3.107-1.187 4.614.333 1.013 1.053 1.746 2.067 2.133-.16-2.627.026-7.387 2.96-10.4.466-.48.92-.907 1.333-1.293.187-.174.347-.334.507-.48a.632.632 0 0 1 .8-.974c.026.014.053.04.08.054.28-.334.466-.68.573-1.027-.027-.04-.067-.067-.08-.107-.507-.813-.88-2.466.213-5.72 1.187-3.466 3.734-3.64 5.147-3.44l1.387.214c2.093.266 2.56 1.826 2.76 2.546l2.893 1.44c.24.12.373.36.347.627-.16 1.88-1.147 4.067-3.44 4.067h-1.374Zm-.786 3.373c-.08-1-.267-2-.494-3.24l-.12-.653a.642.642 0 0 1 .134-.534.64.64 0 0 1 .493-.226h2.147c1.493 0 1.96-1.654 2.106-2.467l-2.746-1.36a.581.581 0 0 1-.32-.387L23.08 7.2c-.173-.667-.4-1.507-1.707-1.667l-1.4-.213c-1.8-.267-3.066.6-3.733 2.573-1.027 3.027-.587 4.254-.347 4.627.187.307.4.36.467.36.573.107.973.013 1.267-.267.8-.76.866-2.8.68-4.306a.652.652 0 0 1 .56-.72c.346-.054.666.2.72.56.146 1.173.346 4.066-1.067 5.4-.413.386-1.16.813-2.347.6-.066 0-.133-.04-.186-.054-.147.32-.32.627-.547.92 1.667.894 4.173 1.734 6.533 1.294l-.026.013ZM7.133 8.627a6.438 6.438 0 0 1 3.987-1.854.643.643 0 0 0-.107-1.28A7.615 7.615 0 0 0 6.227 7.72C4.947 9.013 4.147 10.707 4 12.507a.642.642 0 0 0 .587.693h.053a.64.64 0 0 0 .64-.587 6.368 6.368 0 0 1 1.853-3.986Zm1.4 1.4a4.594 4.594 0 0 0-1.32 2.853.642.642 0 0 0 .587.693h.053a.64.64 0 0 0 .64-.586 3.31 3.31 0 0 1 .947-2.054 3.241 3.241 0 0 1 2.053-.946.643.643 0 0 0 .587-.694.651.651 0 0 0-.693-.586 4.594 4.594 0 0 0-2.854 1.32Zm2.28 2.28c-.32.32-.506.733-.546 1.186a.642.642 0 0 0 .586.694h.054a.64.64 0 0 0 .64-.587c0-.147.08-.28.173-.387a.58.58 0 0 1 .387-.173.643.643 0 0 0 .586-.693.634.634 0 0 0-.693-.587c-.453.04-.867.227-1.187.547Z"
        />
      </symbol>
      <symbol
        id="icon-socialization-sounds"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M8.144 26.693h7.938a4.144 4.144 0 0 0 4.143-4.143V9.45a4.144 4.144 0 0 0-4.143-4.143H8.144A4.144 4.144 0 0 0 4 9.451V22.55a4.144 4.144 0 0 0 4.144 4.143ZM28 11.896v8.206M24.11 8.724v14.553"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.618 18.31a2.307 2.307 0 1 1-4.613 0 2.307 2.307 0 0 1 4.613 0Z"
          clipRule="evenodd"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.62 18.308v-6.925s.6 1.56 2.212 1.887"
        />
      </symbol>
      <symbol
        id="icon-socialization-car-rides"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M20.207 18.075h2.301M8.84 18.075h2.3M4.165 12.716a81.937 81.937 0 0 0 23.005 0"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M4.169 24.415a1.28 1.28 0 0 0 1.28 1.284h2.536a1.28 1.28 0 0 0 1.28-1.28v-.524c0-.707.573-1.28 1.28-1.28h10.257c.706 0 1.28.573 1.28 1.28v.524c0 .707.572 1.28 1.28 1.28h2.553a1.28 1.28 0 0 0 1.28-1.28v-6.691a4.889 4.889 0 0 0-.945-2.886l-1.492-2.002a2.295 2.295 0 0 1-.286-.546l-1.343-3.731a2.868 2.868 0 0 0-2.214-1.853 33.574 33.574 0 0 0-10.458 0 2.868 2.868 0 0 0-2.201 1.853l-1.343 3.73c-.07.187-.167.363-.286.523L5.11 14.904a4.837 4.837 0 0 0-.92 2.848l-.021 6.663Z"
        />
      </symbol>
      <symbol
        id="icon-socialization-stimulation"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M4 26.319h24M15.821 5.68c.301 1.96.24 3.937-.05 5.804M10.937 26.318c-.733-3.422-2.85-8.252-6.622-11.495 0 0 2.126 8.084 1.715 11.495"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14.201 18.036c-1.174-3.061-2.991-6.412-5.787-9.002 1.598 6.71.383 11.537.383 11.537M15.896 26.319s1.2-13.006 8.056-19.36c-2.087 9.063-.101 14.121-.101 14.121"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M21.208 26.319c.733-3.422 2.707-5.736 6.48-8.979 0 0-1.985 5.567-1.573 8.979"
        />
      </symbol>
      <symbol
        id="icon-socialization-people"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.963 27.157c-4.318 0-8.008-.653-8.008-3.269s3.666-4.893 8.008-4.893c4.32 0 8.008 2.256 8.008 4.87 0 2.615-3.665 3.293-8.008 3.293ZM15.963 15.265a5.133 5.133 0 1 0-5.133-5.132 5.116 5.116 0 0 0 5.098 5.132h.035Z"
          clipRule="evenodd"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M24.483 13.856a3.868 3.868 0 0 0-.222-7.524M25.257 18.06c2.34 0 4.336 1.584 4.336 3 0 .834-.689 1.742-1.734 1.987M7.445 13.856a3.868 3.868 0 0 1 .22-7.524M6.669 18.06c-2.339 0-4.336 1.584-4.336 3 0 .834.69 1.742 1.736 1.987"
        />
      </symbol>
      <symbol
        id="icon-socialization-children"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M16 28C9.373 28 4 22.628 4 16 4 9.373 9.373 4 16 4c6.628 0 12 5.373 12 12 0 6.628-5.372 12-12 12Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M8 7.056A11.97 11.97 0 0 1 12 16a11.97 11.97 0 0 1-4 8.945M24 7.056A11.97 11.97 0 0 0 20 16a11.97 11.97 0 0 0 4 8.945"
        />
      </symbol>
      <symbol
        id="icon-socialization-new-places"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M18.71 26.793v-.047c.01-4.67-1.377-8.128-4.294-5.646-2.482 2.093-4.364 2.811-5.6 2.987"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M7.041 21.592c1.622 3.382 5.222 5.431 9.2 5.431 6.23 0 11.28-5.048 11.28-11.277 0-6.229-5.05-11.278-11.28-11.278"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M19.297 4.896c-.211.61-.987 3.235.754 5.07 1.976 2.081 3.67 2.2 3.611 4.457-.047 2.272-2.846 2.236-1.33 5.836.624 1.482 1.365 2.658 1.788 3.551M9.681 6.549v-.072m-.009-.212a.313.313 0 1 0 .004.624.313.313 0 0 0-.004-.624ZM14.213 8.851V8.78m-.01-.213a.313.313 0 1 0 .004.624.313.313 0 0 0-.004-.624ZM5.169 8.851V8.78m-.01-.213a.313.313 0 1 0 .004.624.313.313 0 0 0-.003-.624Z"
        />
        <path
          stroke="currentColor"
          strokeWidth="1.44"
          d="M9.726 15.985c1.898 0 4.307 1.646 4.272-.887-.014-1.9-1.992-3.682-4.272-3.684-2.294 0-4.573 1.937-4.257 3.912.35 2.29 2.574.66 4.257.66Z"
        />
      </symbol>
      <symbol
        id="icon-socialization-other-dogs"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M19.978 18.463c.225.57.988 1.88 2.246 2.554"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M16.84 13.446c-.34 1.802-.655 5.963 2.408 5.583 0 0 2.276-1.334 1.016-5.947-.77-2.818-2.613-3.71-4.366-3.56l-1.546.122c-2.016.134-2.292 1.802-2.179 2.515l-3.327 1.414c.03 1.236.607 3.65 2.68 3.415 2.072-.235 2.747-.412 2.826-.47.412 1.265.227 3.53-.854 5.305"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M21.165 4.225H10.37c-3.774 0-6.122 2.664-6.122 6.434V20.83c0 3.77 2.348 6.434 6.123 6.434h10.795c3.774 0 6.123-2.664 6.123-6.434V10.66c0-3.77-2.36-6.434-6.123-6.434Z"
        />
      </symbol>
      <symbol
        id="icon-socialization-other-animals"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M11.46 9.234v.011M21.2 18.383v.01M14.752 10.53c-.22 1.173-.434 3.098-.114 4.694m4.651-5.175c-1.02-3.735-3.461-4.643-5.784-4.443l-2.05.162C8.786 5.944 8.42 7.88 8.57 8.825L4.16 10.7c.04 1.638.804 4.838 3.55 4.525 2.747-.312 3.642-.546 3.746-.624.546 1.678.4 7.145-1.032 9.497M27.494 25.91c.346-2.172.346-4.67.346-4.67 0-4.077-2.586-8.387-6.02-8.387v2.381c-1.657 0-3.066.637-3.762 2.332-.403.98-1.066 1.5-2.033 1.5-.263 1.066.51 3.06 2.35 3.338 1.616.243 2.347 1.083 2.406 2.8"
        />
      </symbol>
      <symbol
        id="icon-socialization-scent-intro"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M18.906 27.354H12.38M15.81 12.555c-.316 1.49-1.813 2.453-3.536 4.223-2.937 3.015-3.003 7.998-2.703 10.807-4.03-.722-4.653-5.291-2.06-8.047M14.562 19.46c2.722 0 4.503 4.65 1.914 7.651"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M24.954 27.434H22.45c-.162-1.992-1.087-3.341 0-7.835.76-3.146.319-4.923-.262-8.021h2.143c2.068 0 2.701-2.277 2.802-3.476l-3.151-1.567c-.187-.604-.363-2.118-2.313-2.365l-1.378-.212c-1.694-.248-3.524.31-4.436 3.004-1.492 4.41-.193 5.728.642 5.836 2.954.548 2.889-3.513 2.664-5.284"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M14.1 14.094c1.72 1.224 6.067 3.269 9.699 1.657M11.293 5.404a7.032 7.032 0 0 0-6.425 6.426M11.66 8.606a3.928 3.928 0 0 0-3.59 3.589M12.277 11.663a1.26 1.26 0 0 0-1.15 1.15"
        />
      </symbol>
      <symbol
        id="icon-socialization-daily-handling"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M13.456 9.912v.014M15.543 26.891c-1.477.05-2.78-.168-3.605-.418 1.914-3.141 2.24-7.15 1.511-9.392-.139.104-.92.245-4.588.661-3.67.417-4.69-3.856-4.743-6.045l5.475-2.33c-.201-1.263.289-4.215 3.856-4.452l2.737-.216c3.104-.267 6.366 1.312 7.729 6.302.181.664.32 1.29.425 1.878"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.44"
          d="M17.852 11.644a22.062 22.062 0 0 0-.346 2.92M24.284 19.733a1.644 1.644 0 1 1 3.274-.29 1.644 1.644 0 0 1-3.274.29ZM24.924 20.951l-4.99 5.947M21.087 19.733a1.644 1.644 0 1 0-3.274-.29 1.644 1.644 0 0 0 3.274.29ZM20.447 20.951l4.99 5.947"
        />
      </symbol>
    </svg>
  );
}
